import React, { useContext, useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import content from "../../services/content";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from '@mui/material/styles';
import firebase from "../../firebase";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Iframe from "../Iframe";

const WelcomeDescription = ({ classes, userState }) => {
  const language = useContext(LanguageContext);
  const [introVideoKey, setIntroVideoKey] = useState("intro.video");
  const [introVideo, setIntroVideo] = useState(
    content["intro.video"]["maharashtra"]
  );
  const theme = useTheme();
  useEffect(() => {
    if (userState) {
      setIntroVideo(content["intro.video"][userState.name_en.toLowerCase()]);
      setIntroVideoKey(introVideoKey + userState.name_en.toLowerCase());
    } else {
      setIntroVideo(content["intro.video"]["maharashtra"]);
      setIntroVideoKey(introVideoKey + "maharashtra");
    }
  }, [userState]);

  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <div style={{ background: "#FFF8E5" }}>
      <div
        className={
          isSmallDevice
            ? classes.welcomeMessageContainer
            : classes.welcomeMessageContainerDesktop
        }
      >
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className={classes.welcomeText}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <Typography
                variant={"h5"}
                style={{ fontWeight: "bold" }}
                align={"justify"}
              >
                {messages["landing.title1"][language]}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <Typography
                variant={"h5"}
                style={{ fontWeight: "bold", marginTop: "8px" }}
                align={"justify"}
              >
                {messages["landing.title2"][language]}
              </Typography>
            </Grid>
          </Grid>

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <Typography
                variant={"body1"}
                style={{ marginTop: "8px", fontWeight: "bold" }}
                align={"center"}
              >
                {messages["landing.title3"][language]}
              </Typography>
            </Grid>
          </Grid>
        </div>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.welcomeJoinNowButton}
        >
          <Grid item>
            <Button
              href={"/join"}
              size={"large"}
              color={"primary"}
              variant={"contained"}
              endIcon={<ArrowForwardIcon />}
              style={{
                fontWeight: "bold",
              }}
              onClick={() => {
                let stateName = userState
                  ? userState.name_en.toLowerCase()
                  : "maharashtra";
                firebase.analytics().logEvent("joingold_clicked", {
                  state_name: stateName,
                  page: "landing",
                  section: "spotlight",
                });
              }}
            >
              {messages["landing.tryFree"][language]}
            </Button>
          </Grid>
        </Grid>
      </div>

      <br />
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <img
            src={"../../icons/namaste.png"}
            alt=""
            style={{ height: "24px" }}
          />
        </Grid>
        <Grid item>
          <Typography
            variant={"h6"}
            align={"justify"}
            style={{ fontWeight: "bold" }}
          >
            {messages["landing.namaste"][language]}
          </Typography>
        </Grid>
      </Grid>

      {/* welcome video */}
      {introVideo && !_.isEmpty(introVideo) && (
        <div className={classes.goldVideoContainer}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography
                variant={"h6"}
                align={"center"}
                style={{
                  fontWeight: "bold",
                  margin: "8px 0px",
                }}
              >
                {messages["landing.agrostarGold"][language]}
              </Typography>
            </Grid>
          </Grid>

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} md={8} style={{ margin: "0px 0px 24px" }}>
              {/* <CardMedia
                component="video"
                controlsList="nodownload"
                image={introVideo.video}
                title="title"
                poster={introVideo.background}
                controls
                
                onPlay={() => {
                  let stateName = userState
                    ? userState.name_en.toLowerCase()
                    : "maharashtra";
                  firebase
                    .analytics()
                    .logEvent("intro_video_playback_started", {
                      state_name: stateName,
                      key: introVideoKey,
                      page_name: window.location.pathname,
                    });
                }}
                onEnded={() => {
                  let stateName = userState
                    ? userState.name_en.toLowerCase()
                    : "maharashtra";
                  firebase.analytics().logEvent("intro_video_playback_ended", {
                    state_name: stateName,
                    key: introVideoKey,
                    page_name: window.location.pathname,
                  });
                }}
              /> */}
              <div
                style={{
                  overflow: "hidden",
                  paddingBottom: "56.25%",
                  position: "relative",
                  height: "0",
                }}
              >
                <Iframe src={introVideo.video} />
              </div>
            </Grid>
          </Grid>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              <Typography variant={"body1"} align={"center"}>
                {messages["landing.aboutAgroStar"][language]}
              </Typography>
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
          <br />

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <Typography variant={"body1"} align={"center"}>
                {messages["landing.wantToJoinCall"][language]}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ margin: "1vh 3.5vh 0vh 0vh" }}
          >
            <Grid item>
              <Button
                href={"/join"}
                size={"large"}
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIcon />}
                onClick={() => {
                  let stateName = userState
                    ? userState.name_en.toLowerCase()
                    : "maharashtra";
                  firebase.analytics().logEvent("joingold_clicked", {
                    state_name: stateName,
                    page: "landing",
                    section: "spotlight",
                  });
                }}
              >
                {messages["landing.tryFree"][language]}
              </Button>
            </Grid>
          </Grid>
          <br />
        </div>
      )}
    </div>
  );
};

export default WelcomeDescription;
